import React from 'react'

const Action = ({ loading, error, success, children }) => {
  const renderIcon = ({ type }) => {
    if (type === 'success') {
      return <i className="fal fa-check"></i>
    }

    if (type === 'error') {
      return <i className="fal fa-times"></i>
    }
  }
  const renderMessage = ({ type, message }) => {
    if (message && type) {
      return (
        <span className={`form-action-message form-action-message-${type}`}>
          {message}
        </span>
      )
    }
  }
  const priorityMessage =
    (error && { type: 'error', message: error }) ||
    (success && { type: 'success', message: success }) ||
    {}
  const messageElement = renderMessage(priorityMessage)
  let loadingElement = null

  if (loading) {
    loadingElement = <i className="fal fa-circle-notch fa-spin fa-fw" />
  }

  //Icon indicating success or failure, no text
  const iconElement = renderIcon(priorityMessage)

  /*
   *console.log("loading element", loadingElement, "message element", messageElement,
   *    "icon element", iconElement, "error", error, "success", success,
   *    "priorityMessage", priorityMessage);
   */

  return children(loadingElement, messageElement, iconElement)
}

export default Action
